var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// import { restClient } from '@cta-portal/webapp-common/lib/api/client'
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
// import { useContext } from 'react'
import styled from 'styled-components';
import logoutIcon from '../../assets/images/icons/common/icon-logout-purple.png';
// import { SettingsContext } from '../../context/settings'
// import { UserContext } from '../../context/user'
import { appEnv } from '@cta-portal/webapp-common/lib/env';
export default function Logout(_a) {
    var visible = _a.visible;
    var t = useI18n().t;
    // const { setShowRightMenu } = useContext(SettingsContext)
    // const { reconnectUser } = useContext(UserContext)
    // async function logout() {
    //   setShowRightMenu(false)
    //   await restClient.logout()
    //   await reconnectUser()
    // }
    return (_jsxs(Container /* onClick={logout} */, { visible: visible, href: "".concat(appEnv.server.ssoUrl, "/logout?ref=").concat(encodeURIComponent("".concat(appEnv.client.portalUrl, "/"))), children: [_jsx("img", { alt: "logout", src: logoutIcon }), _jsx("p", { children: t('common.logout') })] }));
}
var Container = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  border-top: ", ";\n  bottom: 0;\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  height: 56px;\n  justify-content: flex-start;\n  padding: 0 16px;\n  position: fixed;\n  right: 0;\n  transition: width 200ms ease-in-out;\n  width: ", ";\n\n  @media screen and (max-width: 824px) {\n    width: ", ";\n  }\n\n  &:hover {\n    opacity: 1;\n\n    & > p {\n      color: ", ";\n    }\n  }\n\n  & > img {\n    height: 24px;\n    width: 24px;\n  }\n\n  & > p {\n    font-size: 16px;\n    font-weight: 600;\n    text-transform: uppercase;\n  }\n"], ["\n  align-items: center;\n  background-color: ", ";\n  border-top: ", ";\n  bottom: 0;\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  height: 56px;\n  justify-content: flex-start;\n  padding: 0 16px;\n  position: fixed;\n  right: 0;\n  transition: width 200ms ease-in-out;\n  width: ", ";\n\n  @media screen and (max-width: 824px) {\n    width: ", ";\n  }\n\n  &:hover {\n    opacity: 1;\n\n    & > p {\n      color: ", ";\n    }\n  }\n\n  & > img {\n    height: 24px;\n    width: 24px;\n  }\n\n  & > p {\n    font-size: 16px;\n    font-weight: 600;\n    text-transform: uppercase;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.layoutNeutralDark;
}, function (_a) {
    var theme = _a.theme;
    return "solid 1px ".concat(theme.palette.purple, "80");
}, function (_a) {
    var visible = _a.visible;
    return (visible ? '460px' : '0');
}, function (_a) {
    var visible = _a.visible;
    return (visible ? '100%' : '0');
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.purple;
});
var templateObject_1;
